export default function SetEditableActionMutator(type, plugin, molten) {
  if (plugin?.id === 'molten.dataViewers.table.SetEditableAction') {
    return {
      ...plugin,
      handles: (cxt, ...rest) => {
        if (cxt?.clientProps.objectType === 'job' || cxt?.clientProps.objectType === 'jobItem') {
          return false;
        }
        return plugin.handles(cxt, ...rest);
      }
    };
  }
  return plugin;
}